import * as React from 'react';
import { Box } from '@mui/material';
import { FastField } from 'formik';

import { NotNull } from '../../shared/utils';
import { QuestionProps, buildFormKey } from '.';
import { CerebroLabel, CerebroRadioGroup, CerebroRadioButton, CerebroInput } from '../../shared/components';

export const DealQuestionMultipleChoice: React.FC<QuestionProps> = ({ question, values, isSubmitting }) => {
	const valueKey = buildFormKey(question, 'value');
	const textKey = buildFormKey(question, 'text');

	const otherIsSelected = question.includeOther && values[valueKey] === 'other';

	const options = React.useMemo(
		() =>
			Object.keys(question)
				.filter(key => key.startsWith('listItem'))
				.map(key => question[key as OptionKeys])
				.filter(NotNull),
		[question]
	);

	return (
		<>
			<CerebroLabel htmlFor={valueKey}>{question.questionText}</CerebroLabel>
			<FastField
				size="small"
				id={valueKey}
				sx={{ marginLeft: 1, marginTop: 2 }}
				as={CerebroRadioGroup}
				name={valueKey}
			>
				{options.map(option => (
					<CerebroRadioButton
						size="small"
						key={`${valueKey}|${option}`}
						value={option}
						disabled={isSubmitting}
					>
						{option}
					</CerebroRadioButton>
				))}

				{question.includeOther && (
					<CerebroRadioButton size="small" value="other" disabled={isSubmitting}>
						Other
					</CerebroRadioButton>
				)}
			</FastField>

			{otherIsSelected && (
				<Box sx={{ marginLeft: 2 }}>
					<FastField
						small
						id={textKey}
						name={textKey}
						as={CerebroInput}
						sx={{ marginTop: 0 }}
						disabled={isSubmitting}
					/>
				</Box>
			)}
		</>
	);
};

type OptionNumbers = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;

type OptionKeys = `listItem${OptionNumbers}`;
